import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import Select from "react-select";
import { useState } from "react";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import moment from "moment";
import "./expenseClaim.css";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));
const token =
  localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
const ExpenseClaimFilter = (props) => {
  const {
    handleSearchYear,
    handleSearchPeriod,
    handleMainRowDialogOpen,
    handleClearYear,
    handleSearch,
    handlePTF,
    postDisable,
  } = props;
  // const [companyName, setCompanyName] = useState("001");
  const [company, setCompany] = useState("");
  const [docNumber, setdocNumber] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const navigate = useNavigate();

  const approvalList = [
    { label: "ALL", value: "ALL" },
    { label: "APPROVED", value: "APPROVED" },
    { label: "NOT APPROVED", value: "NOT APPROVED" },
  ];

  return (
    <>
      <Box className="p-24" sx={{ flexGrow: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className="flex">
              <FormControl className="flex flex-row">
                {/* <div>
                  <label>Company</label>
                  <StyledTextField
                    type="text"
                    variant="outlined"
                    name="company"
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                      handleSearch(e.target.value);
                    }}
                  />
                </div> */}
                <Stack className="mr-16">
                  <label>Company</label>
                  <StyledTextField
                    type="text"
                    variant="outlined"
                    name="company"
                    value={company}
                    onChange={(e) => {
                      setCompany(e.target.value);
                    }}
                  />
                </Stack>
                <Stack className="mr-16">
                  <label>Doc Number</label>
                  <StyledTextField
                    type="text"
                    variant="outlined"
                    name="docNumber"
                    value={docNumber}
                    onChange={(e) => {
                      setdocNumber(e.target.value);
                    }}
                  />
                </Stack>

                <Stack className="mr-16">
                  <label>Doc Start Date</label>

                  <CustomDatePicker
                    className="w-[130px] p-0"
                    format={"dd-MM-yyyy"}
                    name={"fromDate"}
                    value={fromDate}
                    handleChange={(e) => {
                      setFromDate(e);
                    }}
                  />
                </Stack>
                <Stack className="mr-16">
                  <label>Doc End Date</label>
                  <CustomDatePicker
                    className="w-[130px]"
                    format={"dd-MM-yyyy"}
                    name={"toDate"}
                    value={toDate}
                    minDate={fromDate}
                    handleChange={(e) => {
                      setToDate(e);
                    }}
                  />
                </Stack>
                <Stack className="mr-16">
                  <label>Name</label>

                  <StyledTextField
                    type="text"
                    variant="outlined"
                    name="year"
                    value={employeeName}
                    onChange={(e) => {
                      setEmployeeName(e.target.value);
                    }}
                  />
                </Stack>
                <Stack className="mr-16">
                  <label>Remarks</label>
                  <StyledTextField
                    type="text"
                    variant="outlined"
                    name="year"
                    value={remarks}
                    onChange={(e) => {
                      setRemarks(e.target.value);
                    }}
                  />
                </Stack>
                <Stack className="mr-16">
                  <label>Approval Status</label>
                  <Select
                    className="w-[150px]"
                    name="approval_status"
                    placeholder="Status"
                    value={approvalStatus}
                    // defaultValue={approvalList[0]}
                    onChange={(e) => {
                      setApprovalStatus(e);
                    }}
                    options={approvalList}
                    styles={customStyles()}
                  />
                </Stack>

                <div className="mt-16 flex">
                  <Button
                    color="warning"
                    variant="contained"
                    startIcon={
                      <FuseSvgIcon size={18}>
                        heroicons-outline:search
                      </FuseSvgIcon>
                    }
                    sx={{ mr: 1 }}
                    onClick={() => {
                      handleSearch({
                        customerCode: company,
                        docNum: docNumber,
                        docStartDate: fromDate?.length !== 0
                        ? moment(fromDate).format("YYYY-MM-DD")
                        : "",
                        docEndDate: toDate?.length !== 0
                        ? moment(toDate).format("YYYY-MM-DD")
                        : "",
                        empName: employeeName,
                        remarks: remarks,
                        isApproved: approvalStatus?.value
                      });
                    }}
                  />
                  {token?.scope?.includes("ROLE_FINANCE") ||
                  token?.scope?.includes("ROLE_FINMGR") ? (
                    <Button
                      color="warning"
                      variant="contained"
                      disabled={postDisable}
                      onClick={() => {
                        handlePTF();
                      }}
                    >
                      PTF
                    </Button>
                  ) : null}
                </div>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ExpenseClaimFilter;
